/* eslint-disable @typescript-eslint/no-unused-vars */
import type {
  MetricDefinition,
  MetricsConstructor,
  MetricsId,
  MetricsNames,
  ParamsDefault,
  ParamsEcommerce,
  ParamsPageView,
} from '@/services/metrics/types/service.types'

export abstract class Metric implements MetricDefinition {
  ids: MetricsId
  name: MetricsNames
  ecommerce: boolean = false
  exceptionError: Function

  constructor(data: MetricsConstructor) {
    const { name, ids, ecommerce, exceptionError } = data

    this.name = name
    this.ids = ids
    this.ecommerce = ecommerce
    this.exceptionError = exceptionError
  }

  initVendor(): Promise<void> | void {}

  eventPageView(args: ParamsPageView): void {}

  // Метод исключения для Yandex, MyTarget
  eventSendGoal(args: ParamsDefault): void {}

  // Методы отправки ecommerce событый
  eventViewedProduct(args: ParamsEcommerce): void {}

  eventAddProduct(args: ParamsEcommerce): void {}

  eventPurchase(args: ParamsEcommerce): void {}
}
